module.exports = __webpack_public_path__ + "static/media/oy_2.e78c19e5.ogg";